import React from 'react';

// Components
import * as icons from './Icons/Icons';

class CloseWindow extends React.Component {
  render() {
    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <i className="icn--blue"><icons.iconBadgeCheck /></i>
          <h1 className="panel__title">All Set!</h1>
          <p>Your appointment has been scheduled. Close this tab to return to SmarterProctoring</p>
        </div>
      </main>
    )
  }
}

export default CloseWindow;


// WEBPACK FOOTER //
// ./src/app/components/CloseWindow.js